import { IApplicationState } from '../../types/redux';

export function selectRubricsLinks(state: IApplicationState) {
  return state.rubricsLinks;
}
